import { Col, Row } from "antd";
import TabsList from "molecules/TabsList";
import Approval from "pages/Approval";
import LeaveReport from "pages/LeaveReport";
import Myleavereport from "pages/Myleavereport";
import { useSelector } from "react-redux";
import { getMenuList, getUserRoleId } from "redux/selectors";
import { hasViewAccess } from "utils/AccessUtils";
import LeaveEncashmentApproval from "./LeaveEncashmentApproval";
import LeaveEncashmentReport from "./LeaveEncashmentReport";
import MyLeaveEncashment from "./MyLeaveEncashment";

// Menu paths that control each tab (role menu list, see Roles & Permissions).
export const LEAVE_ENCASHMENT_MENUS = {
  MY_LEAVE_ENCASHMENT: "myleaveencashment",
  APPROVAL: "leaveencashmentapproval",
  REPORT: "leaveencashmentreport",
};

// Tabs the current role can view; each tab is { id, label, component, menuPath }.
const PermittedTabs = ({ tabs }) => {
  const menuList = useSelector(getMenuList);
  const userRoleId = useSelector(getUserRoleId);
  const roleMenus = menuList?.[userRoleId] || Object.values(menuList || {})[0];
  const items = tabs.filter((tab) => hasViewAccess([tab.menuPath], roleMenus));
  if (!items.length) return null;
  return <TabsList tabId={items[0].id} items={items} />;
};

// Approvals page: existing leave approvals + leave encashment approvals.
export const ApprovalWithEncashment = () => (
  <PermittedTabs
    tabs={[
      { id: "leave", label: "Leave", component: <Approval />, menuPath: "approvals" },
      {
        id: "leaveEncashment",
        label: "Leave Encashment",
        component: <LeaveEncashmentApproval />,
        menuPath: LEAVE_ENCASHMENT_MENUS.APPROVAL,
      },
    ]}
  />
);

// Leave report page: existing leave report + leave encashment report.
export const LeaveReportWithEncashment = () => (
  <PermittedTabs
    tabs={[
      { id: "leave", label: "Leave", component: <LeaveReport />, menuPath: "leave-report" },
      {
        id: "leaveEncashment",
        label: "Leave Encashment",
        component: <LeaveEncashmentReport />,
        menuPath: LEAVE_ENCASHMENT_MENUS.REPORT,
      },
    ]}
  />
);

// Employee's Leave History page: own leaves + own leave encashment requests.
export const MyLeaveReportWithEncashment = () => (
  <>
    <Row className="page-title">
      <Col span={12} className="page-title-head">
        Leave History
      </Col>
    </Row>
    <PermittedTabs
      tabs={[
        {
          id: "leave",
          label: "Leave",
          component: <Myleavereport hideTitle />,
          menuPath: "myleavereport",
        },
        {
          id: "leaveEncashment",
          label: "Leave Encashment",
          component: <MyLeaveEncashment />,
          menuPath: LEAVE_ENCASHMENT_MENUS.MY_LEAVE_ENCASHMENT,
        },
      ]}
    />
  </>
);
